import {useTranslation} from '../../i18n/translation';
import React, {useRef, useEffect, useState} from "react";
import {Canvas, useThree} from "@react-three/fiber";
import { OrbitControls, useGLTF} from "@react-three/drei";
import "../../css/model3d.css";

// Компонент для загрузки и отображения 3D модели
export function Model({ url, position = [0, 0, 0] }) {
    const { scene } = useGLTF(url);
    return <primitive object={scene} position={position} />;
}

export function Model3dButton({ formVisible, setFormVisible }) {
    const {t} = useTranslation();
    return (
        <div className={"model3d-button"}>
            <span onClick={() => setFormVisible(!formVisible)}>
                {t("Посмотреть в 3D")}
            </span>
        </div>

    );
}

// Вспомогательный компонент для логирования камеры
function CameraLogger({ onCameraUpdate }) {
    const { camera } = useThree();

    useEffect(() => {
        const logCamera = () => {
            const { position, rotation } = camera;
            const cameraData = {
                position: [position.x, position.y, position.z],
                rotation: [rotation.x, rotation.y, rotation.z]
            };
            onCameraUpdate(cameraData);
        };

        // Логируем при каждом изменении камеры
        const interval = setInterval(logCamera, 1000); // Логируем раз в секунду

        return () => clearInterval(interval);
    }, [camera, onCameraUpdate]);

    return null;
}

export function Model3dForm({
                                formVisible,
                                setFormVisible,
                                model,
                                onCameraUpdate = (data) => console.log('Camera:', data) // Колбэк для логирования
                            }) {
    const controlsRef = useRef();
    const [cameraInitialized, setCameraInitialized] = useState(false);

    const modelStyles = model.styles ? model.styles : {
        "backgroundColor": "#100e0e"
    };

    const modelCamera = model.camera? {
        initialCameraPosition: model.camera.p,
        initialCameraRotation: model.camera.r
    } : {
        initialCameraPosition: [80, 80, 80],
        initialCameraRotation: [0, 0, 0]
    }

    // Сбрасываем камеру при открытии формы
    useEffect(() => {
        if (formVisible && controlsRef.current) {
            controlsRef.current.reset();
            setCameraInitialized(false);
        }
    }, [formVisible]);

    return (
        <div className={`product-card-order-formWrapper ${formVisible ? "product-card-order-formVisible" : ""}`}>

            {formVisible?
                <div className={"model3dForm"} style={modelStyles}>
                    <div className={"model3d-closeForm"} onClick={() => setFormVisible(false)}>
                        <svg viewBox="0 0 23 23" width="70%" height="75%">
                            <path d="M21,4.46158263L19.5384174 3 12 10.5384174 4.46158263 3 3 4.46158263 10.5384174 12 3 19.5384174 4.46158263 21 12 13.4615826 19.5384174 21 21 19.5384174 13.4615826 12z"> </path>
                        </svg>
                    </div>
                    <div style={{ width: "100%", height: "100%", backgroundColor: "transparent", zIndex: 0 }}>
                        <Canvas
                            camera={{
                                position: modelCamera.initialCameraPosition,
                                rotation: modelCamera.initialCameraRotation,
                                fov: 50
                            }}
                        >
                            {/* Компонент для логирования камеры */}
                            <CameraLogger onCameraUpdate={onCameraUpdate} />

                            {/* Принудительная установка начального положения */}
                            {!cameraInitialized && (
                                <SetCameraPosition
                                    position={modelCamera.initialCameraPosition}
                                    rotation={modelCamera.initialCameraRotation}
                                    onReady={() => setCameraInitialized(true)}
                                />
                            )}

                            <ambientLight intensity={0.5} />
                            <directionalLight position={[10, 10, 10]} intensity={5} />
                            <directionalLight position={[-10, -10, -10]} intensity={1} />

                            {model.models.map(url => <Model key={url} url={`/stl/${url}`} />)}

                            <OrbitControls
                                ref={controlsRef}
                                enablePan={true}
                                enableZoom={true}
                                enableRotate={true}
                            />
                        </Canvas>
                    </div>
                </div> : null
            }

            <div
                onClick={() => setFormVisible(false)}
                className={`darkSpace ${formVisible ? "darkSpaceVisible" : ""}`}
            > </div>
        </div>
    );
}

// Компонент для принудительной установки начального положения
function SetCameraPosition({ position, rotation, onReady }) {
    const { camera } = useThree();

    useEffect(() => {
        camera.position.set(...position);
        camera.rotation.set(...rotation);
        camera.updateProjectionMatrix();
        onReady();
    }, [camera, position, rotation, onReady]);

    return null;
}
